export const LoadingComments = () => (
  <div className="mt-4 border-t border-gray-200 px-4 py-5 sm:px-6 w-full">
    <dl className="w-full space-y-4">
      <dd className="mt-1 flex items-center gap-2">
        <span className="h-12 w-12 rounded-full bg-neutralColor-light"></span>
        <div className="w-full flex flex-col gap-2">
          <span className="h-2 bg-neutralColor-light w-full rounded-md"></span>
          <span className="h-2 bg-neutralColor-light w-2/3 rounded-md"></span>
        </div>
      </dd>
      <dd className="mt-1 flex items-center gap-2">
        <span className="h-12 w-12 rounded-full bg-neutralColor-light"></span>
        <div className="w-full flex flex-col gap-2">
          <span className="h-2 bg-neutralColor-light w-full rounded-md"></span>
          <span className="h-2 bg-neutralColor-light w-1/2 rounded-md"></span>
        </div>
      </dd>
      <dd className="mt-1 flex items-center gap-2">
        <span className="h-12 w-12 rounded-full bg-neutralColor-light"></span>
        <div className="w-full flex flex-col gap-2">
          <span className="h-2 bg-neutralColor-light w-full rounded-md"></span>
          <span className="h-2 bg-neutralColor-light w-3/5 rounded-md"></span>
        </div>
      </dd>
    </dl>
  </div>
);
